// src/redux/inventoryitemSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  get_inventoryitem,
  add_inventoryitem,
  update_inventoryitem,
  delete_inventoryitem,
  get_inventoryitem_list,
} from '../Service/ApiServices.js';
import { toast } from 'react-toastify';

const initialState = {
  inventoryitem: [],
  inventoryitemlist:[],
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
   name:"",
    category:"",
    sub_category:"",
    description:"",
    unit:"",
    reorder_level:0,
    opening_stock:0,
    purchase_price:0,
    sale_price:0,
  },
};

// Async Thunks for API Calls
export const fetchinventoryitemList = createAsyncThunk(
    'inventoryitem/fetchinventoryitemlist',
    async ({school_id,token, signal }, { rejectWithValue }) => {
      try {
        const response = await get_inventoryitem_list(school_id,token, signal);
        if (response.status) {
          return response.response;
        } else {
          return rejectWithValue(response.response.message);
        }
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
  // Async Thunks for API Calls


// Async Thunks for API Calls
export const fetchinventoryitem = createAsyncThunk(
  "inventoryitem/fetchinventoryitem",
  async ({ page, page_size,school_id,search, token, signal }, { rejectWithValue }) => {

    try {
      const response = await get_inventoryitem(page, page_size,school_id,search,token, signal);

        
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



export const createinventoryitem = createAsyncThunk(
  "inventoryitem/createinventoryitem",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_inventoryitem(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateinventoryitem = createAsyncThunk(
  "inventoryitem/updateinventoryitem",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_inventoryitem(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteinventoryitem = createAsyncThunk(
  "inventoryitem/deleteinventoryitem",
  async ({ ids,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_inventoryitem({ ids }, school_id,token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// inventoryitem Slice
const inventoryitemSlice = createSlice({
  name: 'inventoryitems',
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(reduxState, action) {
        reduxState.formData = { ...action.payload };
      },
    resetFormData(state) {
      state.formData = {
       name:"",
    category:"",
    sub_category:"",
    description:"",
    unit:"",
    reorder_level:0,
    opening_stock:0,
    purchase_price:0,
    sale_price:0,
      };
    },
    setinventoryitem(state, action) {
      state.inventoryitem = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
 
  },
  extraReducers: (builder) => {
    builder
    .addCase(fetchinventoryitemList.fulfilled, (state, action) => {
        state.inventoryitemlist = action.payload.data;
      })
      .addCase(fetchinventoryitemList.rejected, (state, action) => {
        state.inventoryitemlist = [];
      })
     
       // Fetch inventoryitem
       .addCase(fetchinventoryitem.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchinventoryitem.fulfilled, (state, action) => {
        state.loading = false;
        state.inventoryitem = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchinventoryitem.rejected, (state, action) => {
        state.loading = false;
        state.inventoryitem = [];
        state.error = action.payload;
      })

      // Add inventoryitem
      .addCase(createinventoryitem.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createinventoryitem.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createinventoryitem.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage);  
        state.IsEditing = false;
      })
      // Update inventoryitem
      .addCase(updateinventoryitem.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateinventoryitem.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updateinventoryitem.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        state.IsEditing = false;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage); 
      })
      // Delete inventoryitem
      .addCase(deleteinventoryitem.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteinventoryitem.fulfilled, (state, action) => {
        state.loading = false;
        console.log(action.payload);
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deleteinventoryitem.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {   setinventoryitem,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setPageSize } = inventoryitemSlice.actions;
export default inventoryitemSlice.reducer;
